// @flow
import * as React from "react";
import { Field, Form, Formik } from "formik";
import Box from "@material-ui/core/Box";
import { TextField } from "formik-material-ui";
import {
  Button,
  LinearProgress,
} from "@material-ui/core";
import { v4 as uuid } from "uuid";
import { useFirestore } from "reactfire";
import { useSnackbar } from "notistack";
import moment from "moment";
import type { Opponent, Team } from "../../common/types";
import validation from "../../common/validation";
import adminForms from "./adminForms";

type Props = {
  teams: [Team],
  opponents: [Opponent],
  locations: [Location],
};

function AdminAddGame({ teams, opponents, locations }: Props) {
  const firestore = useFirestore();
  const gamesRef = firestore.collection("games");
  const { enqueueSnackbar } = useSnackbar();

  const fields = (touched, errors) =>
    adminForms.getGameFields(touched, errors, opponents, teams, locations);

  return (
    <Formik
      initialValues={{
        date: "",
        time: "",
        team: null,
        opponent: null,
        location: null,
        isHomegame: false,
      }}
      validationSchema={validation.validGameForm}
      onSubmit={async (values) => {
        const id = uuid();
        const gameDay = moment(`${values.date} ${values.time}`).toISOString();
        const gameValues = {
          date: gameDay,
          teamId: values.team.id,
          opponentId: values.opponent.id,
          locationId: values.location.id,
          isHomegame: values.isHomegame,
          id,
        };
        if (gameValues.date == null) {
          enqueueSnackbar(
            "Ungültiges Datum. Nutze das Format 'YYYY-MM-DD' zur Eingabe.",
            { variant: "error" }
          );
          return;
        }
        await gamesRef
          .doc(id)
          .set(gameValues)
          .then(() => {
            enqueueSnackbar("Spiel hinzugefügt", { variant: "success" });
          })
          .catch((error) => {
            console.error(error);
            enqueueSnackbar(error.message || error, { variant: "error" });
          });
      }}
    >
      {({ submitForm, isSubmitting, resetForm, touched, errors }) => (
        <Form style={{ width: "100%" }}>
          {fields(touched, errors).map(({ name, ...other }) => (
            <Box mb={1} key={name}>
              <Field
                component={TextField}
                name={name}
                variant="filled"
                disabled={isSubmitting}
                {...other}
              />
            </Box>
          ))}
          {isSubmitting ? (
            <LinearProgress mb={1} />
          ) : (
            <Button
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              onClick={submitForm}
              type="submit"
            >
              Hinzufügen
            </Button>
          )}
        </Form>
      )}
    </Formik>
  );
}

export default AdminAddGame;
